import * as React from "react";
import { useDispatch } from "react-redux";
import { useShallowEqualSelector } from "../../../../_helpers/redux";
import { consultNoteActions } from "../../../../../state/models/consultnote";
import { ConsultNoteQuestion } from "../../../../../api/types";
import {
  past_present_focus_preference_options,
  past_present_focus_intensity_options,
} from "./enums";
import { Select as DeprecatedAntdSelect } from "antd";
import QuestionTitle from "../shared/QuestionTitle";
import { Flex, Row } from "../../../../_layout/Flex";
import { SelectSearchProps } from "../shared/SelectSearchProps";
import { getCurrentConsultNoteInfo } from "@/app/consults-and-matching/_hooks";

interface Props {
  question: ConsultNoteQuestion;
  handleEdit: (hasBeenEdited: boolean) => void;
}

export default ({ question, handleEdit }: Props) => {
  const { readOnlyConsultNote } = getCurrentConsultNoteInfo();

  const [past_present_focus_preference, past_present_focus_intensity] =
    useShallowEqualSelector((state) => [
      state.consultnote?.openConsult?.consult_note
        ?.past_present_focus_preference,
      state.consultnote?.openConsult?.consult_note
        ?.past_present_focus_intensity,
    ]);

  const dispatch = useDispatch();

  const handleChange = (key: string, value: string) => {
    handleEdit(true);
    dispatch(
      consultNoteActions.setConsultNoteValue({
        key,
        value,
      }),
    );
  };

  return (
    <div style={{ paddingTop: "15px", paddingBottom: "15px" }}>
      <QuestionTitle
        questionNumber={question.questionNumber}
        titleText={question.title}
        subtitleText={question.subtitle}
        isRequired={question.isRequired}
      />
      {question.instructionText && (
        <div style={{ padding: "6px 0" }}>
          <i style={{ fontSize: "12px" }}>{question.instructionText}</i>
        </div>
      )}
      <Row layout="start start">
        <Flex style={{ paddingTop: "6px", flex: "0 0 12%" }}>
          Focus of Treatment
        </Flex>
        <Flex style={{ marginRight: "15px", flex: "0 0 30%" }}>
          <DeprecatedAntdSelect<string>
            disabled={readOnlyConsultNote}
            style={{ display: "block" }}
            value={past_present_focus_preference}
            onChange={(v) => {
              handleChange("past_present_focus_preference", v);
            }}
            {...SelectSearchProps}
          >
            {past_present_focus_preference_options.map((so: any) => {
              return (
                <DeprecatedAntdSelect.Option key={so.key} value={so.value}>
                  {so.title}
                </DeprecatedAntdSelect.Option>
              );
            })}
          </DeprecatedAntdSelect>
        </Flex>
        <Flex style={{ flex: "0 0 30%" }}>
          <DeprecatedAntdSelect<string>
            disabled={readOnlyConsultNote}
            style={{ display: "block" }}
            value={past_present_focus_intensity}
            onChange={(v) => {
              handleChange("past_present_focus_intensity", v);
            }}
            {...SelectSearchProps}
          >
            {past_present_focus_intensity_options.map((so: any) => {
              return (
                <DeprecatedAntdSelect.Option key={so.key} value={so.value}>
                  {so.title}
                </DeprecatedAntdSelect.Option>
              );
            })}
          </DeprecatedAntdSelect>
        </Flex>
      </Row>
    </div>
  );
};
